import React from 'react';
import { Grid } from 'semantic-ui-react';
import { VariantConsumer, MenuConsumer } from '../../../FoodMenu.context';
import { displayVariantComponentMap } from '../index';
import MenuUtil from '../../../utils/menu';
import ScheduleAvailability from '../navigation/ScheduleAvailability';

function CategoryContainer({ scheduleId }) {
  return (
    <MenuConsumer>
      {({ schedules, categories }) => {
        const schedule = MenuUtil.getScheduleById(schedules, scheduleId);
        const { categories: scheduleCategoryIds, availableDays, startTime, endTime } = schedule;
        const scheduleCategories = MenuUtil.getScheduleCategories(scheduleCategoryIds, categories);

        return (
          <VariantConsumer>
            {({ categoryDisplay }) => {
              const CategoryComponent = displayVariantComponentMap.category[categoryDisplay];
              const categories = scheduleCategories.map(({ _id }) => (
                <CategoryComponent categoryId={_id} key={_id} />
              ));

              if (categoryDisplay === 'Column') {
                return (
                  <div>
                    <ScheduleAvailability
                      availableDays={availableDays}
                      startTime={startTime}
                      endTime={endTime}
                    />
                    <Grid stackable columns={2}>
                      {categories}
                    </Grid>
                  </div>
                );
              }

              return (
                <div>
                  <ScheduleAvailability
                    availableDays={availableDays}
                    startTime={startTime}
                    endTime={endTime}
                  />
                  {categories}
                </div>
              );
            }}
          </VariantConsumer>
        );
      }}
    </MenuConsumer>
  );
}

export default CategoryContainer;
